import { Grid } from "@material-ui/core";
import CcaAcademicYearInput from "components/CcaAcademicYearInput";
import CcaAddressAutoCompleteInput from "components/CcaAddressAutoCompleteInput";
import CustomCcaStudentScheduleDateInput from "components/CustomCcaStudentScheduleDateInput";
import { BooleanInput, TextInput, required } from "react-admin";

interface IStudentCreateCcaDoorToDoorProps {
  setIdCcaAcademicYear: (value: number) => void;
  ccaAcademicYearResources: any;
  ccaIncludeDates: IIncludeDates[];
  ccaExcludeDates: IExcludeDates[];
}

export const StudentCreateCcaDoorToDoor = ({
  setIdCcaAcademicYear,
  ccaAcademicYearResources,
  ccaIncludeDates,
  ccaExcludeDates,
}: IStudentCreateCcaDoorToDoorProps) => {
  return (
    <>
      <Grid item xs={4}>
        <CcaAcademicYearInput parentCallback={setIdCcaAcademicYear} />
      </Grid>

      <Grid item xs={4}>
        <CustomCcaStudentScheduleDateInput
          source="ccaStartedAt"
          label="Start Date *"
          referenceSource={ccaAcademicYearResources}
          includeDates={ccaIncludeDates}
          excludeDates={ccaExcludeDates}
        />
      </Grid>

      <Grid item xs={4}>
        <CcaAddressAutoCompleteInput
          label="Postal Code *"
          source="ccaPostalCode"
          referenceSource="ccaLocationData"
        />
      </Grid>
      <Grid item xs={8}></Grid>

      <Grid item xs={2}>
        <TextInput label="Unit No." source="ccaUnitNumber" />
      </Grid>
      <Grid item xs={2}>
        <TextInput label="Block No." source="ccaBlockNumber" />
      </Grid>
      <Grid item xs={8}></Grid>

      <Grid item xs={4}>
        <TextInput label="Building Name" source="ccaBuilding" />
      </Grid>
      <Grid item xs={8}></Grid>

      <Grid item xs={4}>
        <TextInput label="Street" source="ccaStreet" validate={required()} />
      </Grid>
      <Grid item xs={8}></Grid>

      <Grid item xs={8}></Grid>

      <Grid item xs={2}>
        <BooleanInput
          label="Monday"
          source="isCcaMonday"
          defaultValue={false}
        />
      </Grid>

      <Grid item xs={2}>
        <BooleanInput
          label="Tuesday"
          source="isCcaTuesday"
          defaultValue={false}
        />
      </Grid>

      <Grid item xs={2}>
        <BooleanInput
          label="Wednesday"
          source="isCcaWednesday"
          defaultValue={false}
        />
      </Grid>

      <Grid item xs={2}>
        <BooleanInput
          label="Thursday"
          source="isCcaThursday"
          defaultValue={false}
        />
      </Grid>

      <Grid item xs={2}>
        <BooleanInput
          label="Friday"
          source="isCcaFriday"
          defaultValue={false}
        />
      </Grid>
    </>
  );
};
